import { zPreferenceCardChangeRequestStatus } from 'client/zod.gen';
import z from 'zod';

import { Badge } from 'DesignSystem/ui/badge';

type RequestStatus = z.infer<typeof zPreferenceCardChangeRequestStatus>;

function getColorClasses(status: RequestStatus) {
  switch (status) {
    case 'Pending':
      return 'bg-yellow-100 text-yellow-900 border border-yellow-300';
    case 'Complete':
      return 'bg-green-100 text-green-900 border border-green-300';
    case 'Cancelled':
      return 'bg-white text-zinc-700 border border-zinc-300';
    case 'Automation Error':
      return 'bg-red-100 text-red-900 border border-red-300';
    case 'Approved':
      return 'bg-indigo-100 text-indigo-900 border border-indigo-300';
    default:
      return 'bg-zinc-100 text-zinc-500';
  }
}

export function RequestStatusPill({ status }: { status: RequestStatus }) {
  return (
    <Badge variant="custom" className={getColorClasses(status)}>
      {status}
    </Badge>
  );
}
